<template>
  <div ref="box" class="custom-select" @click="isOpen = !isOpen">

    <div class="select-selected">
      <span>{{ current === 'all' ? t('map.all_cities') : current }}</span>
      <img :src="isOpen ? caretUp : caretDown" alt="toggle" class="filter-icon" />
    </div>

    <div class="select-items" :class="{ 'select-hide': !isOpen }">
      <div class="select-item" @click.stop="choose('all')">{{ t('map.all_cities') }}</div>
      <div v-for="option in options" :key="option" class="select-item" @click.stop="choose(option)">
        {{ option }}
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount } from 'vue';
import caretUp from '@/assets/icons/caret-up-solid.svg';
import caretDown from '@/assets/icons/caret-down-solid.svg';
import { useI18n } from 'vue-i18n';
const { t } = useI18n();

const props = defineProps({
  options:  { type: Array,  default: () => [] },
  current: { type: String, default: 'all' }
});

const emit = defineEmits(['select']);

const isOpen = ref(false);
const box = ref(null);

const choose = option => {
  emit('select', option);
  isOpen.value = false;
}

// close when the user clicks outside
const handleClickOutside = e => {
  if (box.value && !box.value.contains(e.target)) isOpen.value = false;
}

onMounted(() => document.addEventListener('click', handleClickOutside));
onBeforeUnmount(() => document.removeEventListener('click', handleClickOutside));

</script>

<style scoped lang="scss">
.custom-select {
  position: relative;
  width: 100%;
  cursor: pointer;
}

.select-selected {
  display: flex;
  justify-content: left;
  align-items: center;
  padding: 8px 0;
  border-bottom: 1px solid #ddd;
  font-size: 1.25rem;
  font-weight: 600;
  span {
    margin-right: 10px;
  }
}

.filter-icon {
  width: 16px;
  height: 16px;
}

.select-items {
  position: absolute;
  background-color: white;
  top: 100%;
  left: 0;
  right: 0;
  z-index: 99;
  max-height: 250px;
  overflow-y: auto;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  border-radius: 4px;
}

.select-item {
  padding: 12px 16px;
  border-bottom: 1px solid #f8f8f8;
  transition: background-color 0.2s;
}

.select-item:hover {
  background-color: #f5f5f5;
}

.select-hide {
  display: none;
}
</style>
